import { type ReactNode } from 'react';
import { Trash2 } from 'lucide-react';

import AdminConfirmDialog from '../admin/AdminConfirmDialog';

type DeleteConfirmModalProps = {
  open: boolean;
  title?: string;
  description?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  isConfirming?: boolean;
  errorMessage?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function DeleteConfirmModal({
  open,
  title = 'Confirmer la suppression',
  description = 'Cette action est irréversible.',
  confirmLabel = 'Supprimer définitivement',
  cancelLabel = 'Annuler',
  isConfirming = false,
  errorMessage = null,
  onConfirm,
  onCancel,
}: DeleteConfirmModalProps) {
  const decoratedDescription = (
    <div className="rounded-lg border border-red-200 bg-red-50 p-3">
      <div className="flex items-start gap-2">
        <span className="mt-0.5 inline-flex h-7 w-7 items-center justify-center rounded-full bg-red-100 text-red-700">
          <Trash2 className="h-4 w-4" aria-hidden />
        </span>
        <div className="text-sm font-medium text-red-900">{description}</div>
      </div>
    </div>
  );

  return (
    <AdminConfirmDialog
      open={open}
      title={title}
      description={decoratedDescription}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      variant="danger"
      isConfirming={isConfirming}
      errorMessage={errorMessage}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
